import isEqual from 'lodash/isEqual';
import { CombineCustomFieldsService } from '../../custom-fields/combine-custom-fields/combine-custom-fields.service';
import { ECustomFieldType } from '../../custom-fields/custom-field-types-enums';
import { GET_CUSTOM_FIELDS } from '../../custom-fields/custom-fields.store';
import { TColumn } from '../../site/site-table/columns/column.model';

export function checkIfColumnMatches(
  savedViewColumn: TColumn,
  tableColumn: TColumn,
  workspaceId: string,
): boolean {
  if (!tableColumn || !savedViewColumn) {
    return true;
  }

  const isFormula =
    GET_CUSTOM_FIELDS()[savedViewColumn.customFieldIds?.[0]]?.type === ECustomFieldType.FORMULA;

  if (isFormula) {
    const match = CombineCustomFieldsService.compareByFormula(
      CombineCustomFieldsService.getGroupedFormulas(workspaceId),
      savedViewColumn.customFieldIds?.[0],
      tableColumn.customFieldIds?.[0],
    );

    return match;
  }

  const nameMismatch = savedViewColumn.name !== tableColumn.name;
  const widthMismatch = savedViewColumn.width !== tableColumn.width;
  const hiddenMismatch = savedViewColumn.hidden !== tableColumn.hidden;
  const groupIndexMismatch = savedViewColumn.groupIndex !== tableColumn.groupIndex;
  const sortIndexMismatch = savedViewColumn.sortIndex !== tableColumn.sortIndex;
  const groupOrderMismatch = savedViewColumn.groupOrder !== tableColumn.groupOrder;
  const sortOrderMismatch = savedViewColumn.sortOrder !== tableColumn.sortOrder;
  const customFieldIdsMismatch =
    savedViewColumn.customFieldIds &&
    tableColumn.customFieldIds &&
    !isEqual(savedViewColumn.customFieldIds, tableColumn.customFieldIds);
  const showTotalMismatch =
    typeof savedViewColumn.showTotal !== 'undefined' &&
    typeof tableColumn.showTotal !== 'undefined' &&
    savedViewColumn.showTotal !== tableColumn.showTotal;
  const indexMismatch = savedViewColumn.index !== tableColumn.index;
  const currencyMismatch =
    typeof savedViewColumn.currency !== 'undefined' &&
    typeof tableColumn.currency !== 'undefined' &&
    savedViewColumn.currency !== tableColumn.currency;
  const decimalPlacesMismatch =
    typeof savedViewColumn.decimalPlaces !== 'undefined' &&
    typeof tableColumn.decimalPlaces !== 'undefined' &&
    savedViewColumn.decimalPlaces !== tableColumn.decimalPlaces;
  const unitMismatch =
    savedViewColumn.unit && tableColumn.unit && savedViewColumn.unit !== tableColumn.unit;
  const subValuesActiveMismatch =
    typeof savedViewColumn.subValuesActive !== 'undefined' &&
    typeof tableColumn.subValuesActive !== 'undefined' &&
    savedViewColumn.subValuesActive !== tableColumn.subValuesActive;

  return !(
    nameMismatch ||
    widthMismatch ||
    hiddenMismatch ||
    groupIndexMismatch ||
    sortIndexMismatch ||
    groupOrderMismatch ||
    sortOrderMismatch ||
    customFieldIdsMismatch ||
    showTotalMismatch ||
    indexMismatch ||
    currencyMismatch ||
    decimalPlacesMismatch ||
    unitMismatch ||
    subValuesActiveMismatch
  );
}
